import { styled } from "@mui/material";
import Button from '@mui/material/Button';

const StyledButton = styled(Button)(() => ({
    textTransform: 'none',
}));

export default StyledButton;